var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37907_48231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.9938V11.9998C0.00221875 13.8398 1.49331 15.3309 3.33334 15.3331H12.6667C14.5067 15.3309 15.9978 13.8398 16 11.9998V5.9198L0 5.9938Z",
    fill: "#5F606D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.00006H8.31466C8.21156 2.00075 8.10966 1.97794 8.01666 1.9334L5.91266 0.877404C5.63491 0.739092 5.32894 0.666998 5.01866 0.666748H3.33331C1.49331 0.668936 0.00221875 2.16003 0 4.00006V4.66072L15.9087 4.58672C15.5613 3.07531 14.2175 2.00315 12.6667 2.00006Z",
    fill: "#5F606D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37907_48231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrFolder);
export default __webpack_public_path__ + "static/media/fi-sr-folder.efcfa11f3ef8dc8407a72153fd3734c4.svg";
export { ForwardRef as ReactComponent };